/**
 * Checks if the current device supports touch input.
 * @returns {boolean} - Returns true if the device is a touch device.
 */
function isTouchDevice() {
  return (
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

// Track the last input method used to distinguish between touch and mouse on hybrid devices.
let lastInputWasTouch = false;
let usingMouseOnTouchDevice = false;

/**
 * Updates the input method tracking based on the event type.
 * This helps distinguish between touch and mouse interactions on hybrid devices.
 * @param {Event} event - The input event (touchstart, touchend, mousemove, mousedown).
 */
function updateInputMethod(event) {
  // If the event is a touch event, mark that touch was used.
  if (event.type.startsWith("touch")) {
    lastInputWasTouch = true;
    usingMouseOnTouchDevice = false;
  } else if (event.type === "mousemove" || event.type === "mousedown") {
    // If mouse is used on a touch device and touch hasn't been used recently, enable mouse mode.
    if (isTouchDevice() && !lastInputWasTouch) {
      usingMouseOnTouchDevice = true;
    } else if (lastInputWasTouch) {
      // If touch was used recently, enable mouse mode and reset after 1 second.
      usingMouseOnTouchDevice = true;
      setTimeout(() => {
        lastInputWasTouch = false;
      }, 1000);
    }
  }
}

// Initialize menu dropdown functionality when DOM is ready.
document.addEventListener("DOMContentLoaded", () => {
  const menuContainer = document.querySelector(".header__inline-menu");
  const menuItems = document.querySelectorAll(".header__inline-menu details");

  // Early return if menu container doesn't exist.
  if (!menuContainer) return;

  // Track input method changes to handle hybrid devices correctly.
  document.addEventListener("touchstart", updateInputMethod, { passive: true });
  document.addEventListener("touchend", updateInputMethod, { passive: true });
  document.addEventListener("mousemove", updateInputMethod, { passive: true });
  document.addEventListener("mousedown", updateInputMethod, { passive: true });

  // Add event listeners to the menu container for various interaction types.
  menuContainer.addEventListener("click", handleEvent);
  menuContainer.addEventListener("pointerdown", handleEvent);
  menuContainer.addEventListener("pointerup", handleEvent);
  menuContainer.addEventListener("mouseover", handleEvent);

  // Handle mouseleave events on each menu item to close dropdowns.
  menuItems.forEach((item) => {
    item.addEventListener("mouseleave", () => {
      // Only close on mouseleave if not a touch device or if mouse is being used on touch device.
      if (!isTouchDevice() || usingMouseOnTouchDevice) {
        item.removeAttribute("open");
      }
      // Remove the active class from body when menu closes.
      document.body.classList.remove("js-mega-menu-active");
    });
  });

  /**
   * Handles various menu interaction events.
   * Opens and closes dropdown menus based on the event type and device capabilities.
   * @param {Event} event - The interaction event (click, pointerdown, pointerup, mouseover, touchstart, touchend).
   */
  function handleEvent(event) {
    // Find the closest details element (menu item) from the event target.
    const item = event.target.closest("details");
    // Early return if no menu item found or it's not within the menu container.
    if (!item || !menuContainer.contains(item)) return;

    // Handle touch start events - open the menu.
    if (event.type === "touchstart") {
      lastInputWasTouch = true;
      usingMouseOnTouchDevice = false;
      // Prevent default behavior on non-touch devices.
      if (!isTouchDevice()) event.preventDefault();
      // Open the menu and add active class to body for backdrop overlay.
      item.setAttribute("open", true);
      document.body.classList.add("js-mega-menu-active");
    }

    // Handle touch end events - close the menu.
    if (event.type === "touchend") {
      // Prevent default behavior on non-touch devices.
      if (!isTouchDevice()) event.preventDefault();
      // Close the menu and remove active class from body.
      item.removeAttribute("open");
      document.body.classList.remove("js-mega-menu-active");
    }

    // Handle mouseover events - open the menu on hover (desktop or mouse on touch device).
    if (
      event.type === "mouseover" &&
      (!isTouchDevice() || usingMouseOnTouchDevice)
    ) {
      // Open the menu and add active class to body for backdrop overlay.
      item.setAttribute("open", true);
      document.body.classList.add("js-mega-menu-active");
    }
  }
});
